<template>
  <v-list-item class="bglogo size-logo-bar" link :to="{ name: 'home' }">
    <v-img src="@/assets/logo_simple.png" max-width="40"></v-img>
    <v-list-item-content class="ml-4">
      <v-list-item-title class="green--text text--lighten-2">
        Portal do
      </v-list-item-title>
      <v-list-item-subtitle class="green--text text--lighten-4 subtitulo-logo">
        Colaborador
      </v-list-item-subtitle>
    </v-list-item-content>
  </v-list-item>
</template>

<script>
export default {};
</script>

<style scoped>
.subtitulo-logo {
  font-weight: bold;
  font-size: 1.1rem;
}

.bglogo {
  background-color: #024206 !important;
}

.size-logo-bar {
  height: 65px !important;
}
</style>